import { useCallback, useRef, useState } from 'react';
import * as am4charts from '@amcharts/amcharts4/charts';
import { Label } from '@amcharts/amcharts4/core';

export function useChartZoom() {
  const [isZoomed, setIsZoomed] = useState(false);
  const chartInstanceRef = useRef<am4charts.XYChart | null>(null);

  const handleChartMount = useCallback((chart: am4charts.XYChart) => {
    chartInstanceRef.current = chart;
    const xAxis = chart.xAxes.getIndex(0) as am4charts.DateAxis;
    const titleText = xAxis.title.text;
    xAxis.title.disabled = true;
    const axisTitle = chart.bottomAxesContainer.createChild(Label);
    axisTitle.text = titleText;
    axisTitle.align = 'center';
    axisTitle.marginBottom = 15;
    axisTitle.fontSize = 12;
    xAxis.events.on('startendchanged', () => {
      const zoomed = xAxis.start > 0.001 || xAxis.end < 0.999;
      setIsZoomed(zoomed);
    });
    return chart;
  }, []);

  const handleResetZoom = useCallback(() => {
    if (chartInstanceRef.current) {
      const xAxis = chartInstanceRef.current.xAxes.getIndex(0) as am4charts.DateAxis;
      xAxis.zoom({ start: 0, end: 1 });
    }
  }, []);

  return { isZoomed, handleChartMount, handleResetZoom };
}
